/**
* Options vue-i18n de donoor.org (chargées par @nuxtjs/i18n).
*
* Le français est la langue source : toute clé absente en anglais retombe sur
* le texte français plutôt que d'afficher la clé brute. Le test
* `tests/unit/i18n/cles.spec.ts` garantit que ce repli ne sert jamais en
* production (mêmes clés des deux côtés).
*/
export default () => ({
	legacy: false,
	fallbackLocale: "fr",
	// Pas d'avertissement console pour les repli/absences : le test des clés
	// fait foi, et la console des donateurs doit rester propre.
	missingWarn: false,
	fallbackWarn: false
});
